import { render, staticRenderFns } from "./AppAlertRadialChart.vue?vue&type=template&id=55baa00f&scoped=true&"
import script from "./AppAlertRadialChart.vue?vue&type=script&lang=js&"
export * from "./AppAlertRadialChart.vue?vue&type=script&lang=js&"
import style0 from "./AppAlertRadialChart.vue?vue&type=style&index=0&id=55baa00f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55baa00f",
  null
  
)

export default component.exports